































import Vue, { PropOptions } from 'vue';

export interface ICalenderDate {
  year: number;
  month: number;
  date: number;
}

export class CCalenderDate implements ICalenderDate {
  public year = 0;
  public month =  0;
  public date = 0;
  constructor(pDate?: Date) {
    const cDate = pDate ? pDate : new Date();
    this.year = cDate.getFullYear();
    this.month =  cDate.getMonth() + 1;
    this.date = cDate.getDate();
  }
}

export default Vue.extend({
  name: 'Calender',
  props: {
    // date: {type: Object as () => ICalenderDate, required: false, default: new CCalenderDate()},
    value: String,
  },
  data() {
    return {
      selectDate: new CCalenderDate(),
      dispYear: 2020,
      dispMonth: 1,
      dispDates: [] as number[],
      dayOfWeeks: ['日', '月', '火', '水', '木', '金', '土'],
    };
  },
  mounted() {
    this.dispMonth = this.selectDate.month;
    this.makeArrayMonth(this.dispYear , this.dispMonth - 1);
  },
  watch: {
    value(date) {
      if (date) {
        // 編集
        // TODO: 「毎年」は未考慮
        this.selectDate = new CCalenderDate(new Date(date));
        this.dispMonth = this.selectDate.month;
      }
      this.makeArrayMonth(this.dispYear , this.dispMonth - 1);
    },
  },
  methods: {
    // 年月変更時処理
    onClickChangeMonth(i: number) {
      const newYYYYMM = new Date(this.dispYear , this.dispMonth - 1 + i);
      this.dispMonth  =  newYYYYMM.getMonth() + 1;
      this.dispYear  =  newYYYYMM.getFullYear();
      this.makeArrayMonth(newYYYYMM.getFullYear(), newYYYYMM.getMonth());
    },
    // 日付選択時処理
    onClickSelectDate(weekIndex: number, dateIndex: number) {
      this.selectDate.year = this.dispYear;
      this.selectDate.month = this.dispMonth;
      this.selectDate.date = Number(this.dispDate(weekIndex, dateIndex));
      this.$emit('selectDate', this.selectDate);
    },
    // 表示位置の日
    dispDate(weekIndex: number, dateIndex: number): string {
      let returnDate = '';
      const index = (weekIndex - 1) * 7 + dateIndex - 1;
      // indexを超える場合は''
      if (this.dispDates.length > index) {
        // 0の場合は''
        if (this.dispDates[index] !== 0) {
          returnDate = String(this.dispDates[index]);
        }
      }
      return returnDate;
    },
    // 日付が選択されているかの確認
    checkSelectDate(weekIndex: number, dateIndex: number): boolean {
      // selectDateとの完全一致
      if ((this.selectDate.year === this.dispYear) &&
          (this.selectDate.month === this.dispMonth) &&
            (this.selectDate.date === Number(this.dispDate(weekIndex, dateIndex))) ) {
        return true;
      }
      return false;
    },
    // 日作成時処理
    makeArrayMonth(year: number, month: number) {
      // 開始日までの曜日を0で埋めた配列を作成
      let dates = [...Array(new Date(year, month, 1).getDay()).keys()].fill(0);
      // そこに今月の日を追加
      dates = dates.concat([...Array(new Date(year, month + 1, 0).getDate() + 1).keys()].filter((n) => (n > 0)));
      this.dispDates = dates;
    },
  },
});

